export const ROOT = 'modalError';

export const OPEN_MODAL_ERROR = `${ROOT}/OPEN_MODAL_ERROR`;
export const CLOSE_MODAL_ERROR = `${ROOT}/CLOSE_MODAL_ERROR`;
